import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { withStyles } from '@material-ui/core/styles';

import Layout from 'components/common/Layout';
import TabNavigation from 'components/common/TabNavigation';
import FacilityCreateEditForm from 'components/settings/FacilityCreateEditForm';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const BusinessFacilityCreate = ({ history, account }) => (
  <Layout variant="settings">
    <Helmet>
      <title>
        {appTitle} {titleSeparator} Create Facility
      </title>
    </Helmet>
    <TabNavigation
      items={[
        {
          text: 'General',
          href: '/settings/business/general',
        },
        {
          text: 'Facilities',
          href: '/settings/business/facilities',
        },
        ...account.Roles.filter(item =>
          item.Name === 'Master Administrator' || item.Name === 'Administrator').length > 0 ?
          [
            {
              text: 'Claim MD Credentials',
              href: '/settings/business/claim-md-credentials',
            },
            {
              text: 'Twilio Credentials',
              href: '/settings/business/twilio-credentials',
            },
          ] : [],
      ]}
    />
    <FacilityCreateEditForm
      form="settingsFacilityCreate"
      onSubmitSuccess={() => {
        history.push('/settings/business/facilities');
      }}
    />
  </Layout>
);

BusinessFacilityCreate.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};

const mapStateToProps = store => ({
  account: store.account,
});

export default connect(mapStateToProps)(BusinessFacilityCreate);



// WEBPACK FOOTER //
// ./src/pages/settings/BusinessFacilityCreate.js